export default __webpack_public_path__ + "static/media/leader-board-bg.313cb600.png";